import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_BEGIN,
  REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_SUCCESS,
  REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_FAILURE,
  REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_DISMISS_ERROR,
} from './constants';

export function fetchSummaryDataFromChannelType(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "site",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getSalesSummaryReport`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            }
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchSummaryDataFromChannelTypeError() {
  return {
    type: REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_DISMISS_ERROR,
  };
}

export function useFetchSummaryDataFromChannelType() {
  const dispatch = useDispatch();

  const { reportsCustomerData, reportsCustomerTotals, customerSummary, fetchSummaryDataFromChannelTypePending, fetchSummaryDataFromChannelTypeError } = useSelector(
    state => ({
      reportsCustomerData: state.reports.reportsCustomerData,
      reportsCustomerTotals: state.reports.reportsCustomerTotals,
      customerSummary: state.reports.customerSummary,
      fetchSummaryDataFromChannelTypePending: state.reports.fetchSummaryDataFromChannelTypePending,
      fetchSummaryDataFromChannelTypeError: state.reports.fetchSummaryDataFromChannelTypeError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchSummaryDataFromChannelType(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSummaryDataFromChannelTypeError());
  }, [dispatch]);

  return {
    reportsCustomerData,
    reportsCustomerTotals,
    customerSummary,
    fetchSummaryDataFromChannelType: boundAction,
    fetchSummaryDataFromChannelTypePending,
    fetchSummaryDataFromChannelTypeError,
    dismissFetchSummaryDataFromChannelTypeError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSummaryDataFromChannelTypePending: true,
        fetchSummaryDataFromChannelTypeError: null,
      };

    case REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsCustomerData: action.data.data,
        reportsCustomerTotals: action.data.totals,
        customerSummary: action.data.summary,
        fetchSummaryDataFromChannelTypePending: false,
        fetchSummaryDataFromChannelTypeError: null,
      };

    case REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSummaryDataFromChannelTypePending: false,
        fetchSummaryDataFromChannelTypeError: action.data.error,
      };

    case REPORTS_FETCH_SUMMARY_DATA_FROM_CHANNEL_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchSummaryDataFromChannelTypeError: null,
      };

    default:
      return state;
  }
}
